module.exports = __webpack_public_path__ + "img/quote-left.310cfeef.svg";